// // import React from 'react';
// // import Header from '../components/Header';
// // import Footer from '../components/Footer';

// // const EconomicImpact = () => {
// //   return (
// //     <>
// //     <Header/>
// //     <div className="py-12">
// //       <div className="text-center mb-8 mt-[8rem]">
// //         <h2 className="text-3xl font-semibold">
// //           Economic impact of the mHUB startup community
// //         </h2>
// //       </div>

// //       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
// //         {/* Infographic Item 1 */}
// //         <div className="infographic-item flex flex-col items-center text-center">
// //           <div className="icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Images-Graphics/icons/icon_coins01_warm02.svg"
// //               alt="Capital Raised"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="text-container">
// //             <h3 className="text-4xl font-bold">$2.02B</h3>
// //             <p className="text-lg text-gray-600">Capital Raised</p>
// //           </div>
// //         </div>

// //         {/* Infographic Item 2 */}
// //         <div className="infographic-item flex flex-col items-center text-center">
// //           <div className="icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Images-Graphics/icons/icon_rocket_warm02.svg"
// //               alt="Products Launched"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="text-container">
// //             <h3 className="text-4xl font-bold">1,702</h3>
// //             <p className="text-lg text-gray-600">Products Launched</p>
// //           </div>
// //         </div>

// //         {/* Infographic Item 3 */}
// //         <div className="infographic-item flex flex-col items-center text-center">
// //           <div className="icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Images-Graphics/icons/icon_paper_warm02.svg"
// //               alt="Patents Awarded"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="text-container">
// //             <h3 className="text-4xl font-bold">565</h3>
// //             <p className="text-lg text-gray-600">Patents Awarded</p>
// //           </div>
// //         </div>

// //         {/* Infographic Item 4 */}
// //         <div className="infographic-item flex flex-col items-center text-center">
// //           <div className="icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Images-Graphics/icons/icon_money_warm02.svg"
// //               alt="Revenue Generated"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="text-container">
// //             <h3 className="text-4xl font-bold">$1.96B</h3>
// //             <p className="text-lg text-gray-600">Revenue Generated</p>
// //           </div>
// //         </div>

// //         {/* Infographic Item 5 */}
// //         <div className="infographic-item flex flex-col items-center text-center">
// //           <div className="icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Web_Pages/icons/icon_user-plus_warm02.svg"
// //               alt="Employees Hired"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="text-container">
// //             <h3 className="text-4xl font-bold">6,809</h3>
// //             <p className="text-lg text-gray-600">Employees Hired</p>
// //           </div>
// //         </div>
// //       </div>
// //     </div>

// //      <div className="py-12">
// //       <div className="text-center mb-8">
// //         <h2 className="text-3xl font-semibold">
// //           Outcomes of enabling U.S. hardtech innovation and commercialization
// //         </h2>
// //       </div>

// //       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mx-[2em]">
// //         {/* Card 1 */}
// //         <div className="grid-item card-accent top benefits flex flex-col items-center text-center p-6 border rounded-lg shadow-lg h-[30rem] bg-white">
// //           <div className="card-icon-container ">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Web_Pages/icons/icon_coins01_warm02.svg"
// //               alt="Creating jobs and growing economies"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="card-text-container">
// //             <h3 className="text-xl font-bold mb-2">Creating jobs and growing economies</h3>
// //             <p className="text-base text-gray-600">
// //               mHUB has supported over 500 manufacturing-based startups and 200 manufacturers in building and launching over 1,700 new hardtech solutions, generating $1.96B in revenue, and creating over 6,800 jobs since 2017.
// //             </p>
// //           </div>
// //         </div>

// //         {/* Card 2 */}
// //         <div className="grid-item card-accent top benefits flex flex-col items-center text-center p-6 border rounded-lg shadow-lg h-[30rem] bg-white">
// //           <div className="card-icon-container mb-5">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Web_Pages/icons/icon_users_warm02.svg"
// //               alt="Strengthening local talent pools"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="card-text-container">
// //             <h3 className="text-xl font-bold mb-2">Strengthening local talent pools</h3>
// //             <p className="text-base text-gray-600">
// //               mHUB has attracted industrial designers, material scientists, engineers, computer scientists, business administrators, and more who use the mHUB ecosystem to find contract and full-time work.
// //             </p>
// //           </div>
// //         </div>

// //         {/* Card 3 */}
// //         <div className="grid-item card-accent top benefits flex flex-col items-center text-center p-6 border rounded-lg shadow-lg h-[30rem] bg-white">
// //           <div className="card-icon-container mb-4">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Web_Pages/icons/icon_user-plus_warm02.svg"
// //               alt="Creating opportunity"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="card-text-container">
// //             <h3 className="text-xl font-bold mb-2">Creating opportunity</h3>
// //             <p className="text-base text-gray-600">
// //               mHUB programs are designed to meet entrepreneurs where they are, putting startups on the right track. From discovery-stage mPOWER and Landis Family Fellowship programs, to growth-stage Pilot and Supply Chain Readiness programs, mHUB is committed to improving startup success outcomes.
// //             </p>
// //           </div>
// //         </div>

// //         {/* Card 4 */}
// //         <div className="grid-item card-accent top benefits flex flex-col items-center text-center p-6 border rounded-lg shadow-lg h-[30rem] bg-white">
// //           <div className="card-icon-container mb-5">
// //             <img
// //               src="https://www.mhubchicago.com/hubfs/Web_Pages/icons/icon_truck_warm02.svg"
// //               alt="Bolstering local supply chains"
// //               className="max-w-full h-auto"
// //             />
// //           </div>
// //           <div className="card-text-container">
// //             <h3 className="text-xl font-bold mb-2">Bolstering local supply chains</h3>
// //             <p className="text-base text-gray-600">
// //               mHUB connects startups to local suppliers to support local manufacturing economies, build supply chain resilience, and ensure the growth of critical technologies happens in the U.S. Members spend $11M annually with manufacturers in the Midwest.
// //             </p>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //     <Footer/>
// //     </>
// //   );
// // };

// // export default EconomicImpact;

















// import React from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { FaChartLine, FaRocket, FaUsers, FaDollarSign, FaGlobe } from "react-icons/fa";

// const stats = [
//   { icon: <FaDollarSign size={40} />, value: "$1.2B", label: "Total Funding" },
//   { icon: <FaRocket size={40} />, value: "912", label: "Products Launched" },
//   { icon: <FaGlobe size={40} />, value: "64", label: "Global Patents" },
//   { icon: <FaChartLine size={40} />, value: "$820M", label: "Annual Revenue" },
//   { icon: <FaUsers size={40} />, value: "4,329", label: "Employees" },
// ];

// const outcomes = [
//   {
//     title: "Boosting the Economy",
//     desc: "Supported 600+ startups to generate over $800M in revenue and thousands of jobs.",
//     icon: <FaDollarSign size={50} />,
//   },
//   {
//     title: "Growing Local Talent",
//     desc: "Attracted engineers, designers and scientists into a fast-growing innovation ecosystem.",
//     icon: <FaUsers size={50} />,
//   },
//   {
//     title: "Creating Opportunities",
//     desc: "Programs helping startups move from idea to market with strategic mentorship.",
//     icon: <FaRocket size={50} />,
//   },
//   {
//     title: "Strengthening Supply Chains",
//     desc: "Connecting founders to regional vendors to improve manufacturing resilience.",
//     icon: <FaGlobe size={50} />,
//   },
// ];

// const EconomicImpact = () => {
//   return (
//     <>
//       <Header />

//       {/* Top Stats */}
//       <section className="py-16 bg-gray-50">
//         <h2 className="text-3xl font-bold text-center mb-12">
//           Economic Impact of Startup Ecosystem
//         </h2>

//         <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 px-4">
//           {stats.map((stat, i) => (
//             <div
//               key={i}
//               className="bg-white rounded-2xl p-6 flex flex-col items-center justify-center shadow hover:-translate-y-1 hover:shadow-xl transition-all"
//             >
//               <div className="text-indigo-600 mb-3">{stat.icon}</div>
//               <h3 className="text-3xl font-bold">{stat.value}</h3>
//               <p className="text-gray-600">{stat.label}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Outcomes */}
//       <section className="py-16">
//         <h2 className="text-3xl font-bold text-center mb-12">
//           Key Outcomes of Innovation Programs
//         </h2>

//         <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
//           {outcomes.map((outcome, i) => (
//             <div
//               key={i}
//               className="bg-white rounded-2xl p-6 flex flex-col items-center text-center shadow hover:shadow-xl hover:-translate-y-1 transition-all h-[28rem]"
//             >
//               <div className="text-indigo-600 mb-4">{outcome.icon}</div>
//               <h3 className="font-bold text-xl mb-2">{outcome.title}</h3>
//               <p className="text-gray-600">{outcome.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };

// export default EconomicImpact;
















import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { FaRocket, FaUsers, FaDollarSign, FaGlobe, FaChartLine } from "react-icons/fa";

const stats = [
  { name: "Total Funding", value: 1200, icon: <FaDollarSign size={40} /> },
  { name: "Products Launched", value: 912, icon: <FaRocket size={40} /> },
  { name: "Global Patents", value: 64, icon: <FaGlobe size={40} /> },
  { name: "Annual Revenue", value: 820, icon: <FaChartLine size={40} /> },
  { name: "Employees", value: 4329, icon: <FaUsers size={40} /> }
];

const COLORS = ["#6366F1", "#FBBF24", "#EC4899", "#34D399", "#60A5FA"];

const outcomes = [
  {
    title: "Boosting the Economy",
    desc: "Supported 600+ startups to generate over $800M in revenue and thousands of jobs.",
    icon: <FaDollarSign size={50} />,
  },
  {
    title: "Growing Local Talent",
    desc: "Attracted engineers, designers and scientists into a fast-growing innovation ecosystem.",
    icon: <FaUsers size={50} />,
  },
  {
    title: "Creating Opportunities",
    desc: "Programs helping startups move from idea to market with strategic mentorship.",
    icon: <FaRocket size={50} />,
  },
  {
    title: "Strengthening Supply Chains",
    desc: "Connecting founders to regional vendors to improve manufacturing resilience.",
    icon: <FaGlobe size={50} />,
  },
];

const EconomicImpact = () => {
  return (
    <>
      <Header />

      <section className="py-16 mt-[8rem] bg-gray-50">
        <h2 className="text-3xl font-bold text-center mb-12">
          Economic Impact of Startup Ecosystem (Pie View)
        </h2>

        <div className="flex mt-[4rem] justify-center">
          <PieChart width={450} height={480}>
            <Pie
              data={stats}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name }) => name}
              outerRadius={180}
              fill="#8884d8"
              dataKey="value"
            >
              {stats.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </div>
      </section>

      {/* Outcomes */}
      <section className="py-16">
        <h2 className="text-3xl font-bold text-center mb-12">
          Key Outcomes of Innovation Programs
        </h2>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
          {outcomes.map((outcome, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 flex flex-col items-center text-center shadow hover:shadow-xl hover:-translate-y-1 transition-all h-[28rem]"
            >
              <div className="text-indigo-600 mb-4">{outcome.icon}</div>
              <h3 className="font-bold text-xl mb-2">{outcome.title}</h3>
              <p className="text-gray-600">{outcome.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default EconomicImpact;
